export default __webpack_public_path__ + "static/media/close-icon.dff4730c.svg";